const Error = ({ message, title }) => (
  <div className="mazda-error has-background-danger has-text-white">
    <div className="error-icon-wrapper">
      <span className="icon">
        <i className="mdi mdi-36px mdi-alert-circle" />
      </span>
    </div>
    <div className="error-content-wrapper">
      {title && <div className='error-title'>{title}</div>}
      <div className='error-message'>{message}</div>
    </div>
  </div>
)

Error.defaultProps = {
  message: 'An error occured'
}

export default Error



// WEBPACK FOOTER //
// ./components/uiLib/Error/index.js